/**
 * MIRE header slots — wired into `mireConfig.header`.
 *
 * No Method or Playbook menu; only the Dashboard link.
 */

import { gotoView } from '#lib/navigation.js';
import type { HeaderItem } from '#lib/components/Header.svelte';

export const dashboard: HeaderItem = {
	label: 'Dashboard',
	action: () => void gotoView('mire')
};
